import { useEffect, useState } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import ScrollToTop from "./home/ScrollToTop";

function PageLayout({ children }) {
  // const [theme, setTheme] = useState("light"); // Default theme
  const [pathname, setPathname] = useState(window.location.pathname);
  const [is404, setIs404] = useState(false);

  // Simulate usePathname with window.location.pathname
  useEffect(() => {
    const handleLocationChange = () => {
      setPathname(window.location.pathname);
    };
    window.addEventListener("popstate", handleLocationChange);
    return () => {
      window.removeEventListener("popstate", handleLocationChange);
    };
  }, []);

  // Initialize theme based on localStorage or system preference
  // useEffect(() => {
  //   const savedTheme = localStorage.getItem("theme");
  //   const systemPrefersDark = window.matchMedia(
  //     "(prefers-color-scheme: dark)"
  //   ).matches;
  //   const initialTheme = savedTheme || (systemPrefersDark ? "dark" : "light");
  //   setTheme(initialTheme);
  //   document.documentElement.classList.toggle("dark", initialTheme === "dark");
  // }, []);

  // Simulate 404 check
  useEffect(() => {
    // Since fetch for HEAD request may not work in non-Next.js environments,
    // you may need to adjust this logic based on your routing setup
    fetch(pathname, { method: "HEAD" })
      .then((res) => {
        if (res.status === 404) {
          setIs404(true);
        } else {
          setIs404(false);
        }
      })
      .catch(() => {
        setIs404(true); // Assume 404 on error
      });
  }, [pathname]);

  const excludedRoutes = [
    "/signin",
    "/signup",
    "/forgot-password",
    "/documentation",
  ];
  const hideLayout = excludedRoutes.includes(pathname) || is404;

  return (
    <>
      {/* <Header /> */}
      <div>
        {!hideLayout && <Header />}
        {children}
        {!hideLayout && <Footer />}
        <ScrollToTop />
      </div>
    </>
  );
}

export default PageLayout;
